<template>
  <b-row>
    <b-col md="4">
      <label>Fecha Oferta*</label>
    </b-col>
    <b-col md="8">
      <b-form-datepicker
        v-model="fechaOferta"
        locale="es-ES"
        :disabled="disabled"
        :start-weekday="1"
        @input="$emit('fechaOfertaCambiada', fechaOferta)"
      />
    </b-col>
  </b-row>
</template>

<script>
import { formatDateForm, formatDateSinZona } from "@/services/date";
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";
import { useTrazabilidadStore } from "@/stores/trazabilidad";

export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useOfertaFormStore, ["oferta"]),
    ...mapState(useTrazabilidadStore, ["fechaOfertaInicial"]),

    fechaOferta: {
      get() {
        let fechaLimpia = formatDateSinZona(this.oferta.fecha);
        return formatDateForm(fechaLimpia);
      },
      set(value) {
        this.oferta.fecha = value;
      },
    },
  },
};
</script>
